var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasFilters
    ? _c(
        "v-menu",
        {
          attrs: {
            "close-on-content-click": false,
            "offset-y": "",
            left: "",
            "nudge-bottom": 8,
            transition: "slide-y-transition",
            "content-class": "base-filter-menu__menu-content",
            "min-width": _vm.resolvedMenuWidth,
            "max-width": _vm.resolvedMenuWidth
          },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  var attrs = ref.attrs
                  return [
                    _vm._t(
                      "filter-button",
                      [
                        _c(
                          "BaseButton",
                          _vm._g(
                            _vm._b(
                              { attrs: { bordered: "", fitContent: "" } },
                              "BaseButton",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c("icon-svg", {
                              attrs: {
                                name: _vm.filterIcon,
                                size: 18,
                                color: "#030309"
                              }
                            }),
                            _vm._v(" " + _vm._s(_vm.filterButtonLabel) + " "),
                            _vm.activeCount > 0
                              ? _c(
                                  "span",
                                  { staticClass: "az-ds-badge-count ml-1" },
                                  [_vm._v(" " + _vm._s(_vm.activeCount) + " ")]
                                )
                              : _vm._e(),
                            _c("icon-svg", {
                              staticClass: "base-filter-menu__chevron",
                              class: {
                                "base-filter-menu__chevron--open": _vm.menu
                              },
                              attrs: {
                                name: "mdi-chevron-down",
                                size: 18,
                                color: "#8E8E8E"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      { on: on, attrs: attrs, count: _vm.activeCount }
                    )
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.menu,
            callback: function($$v) {
              _vm.menu = $$v
            },
            expression: "menu"
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "base-filter-menu__menu",
              style: { width: _vm.resolvedMenuWidth + "px" }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "base-filter-menu__menu-header d-flex align-center justify-space-between"
                },
                [
                  _c(
                    "span",
                    { staticClass: "az-text-primary az-size-14 font-medium" },
                    [_vm._v(" " + _vm._s(_vm.menuTitle) + " ")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "az-text-email-link base-filter-menu__clear",
                      on: { click: _vm.clearFilters }
                    },
                    [_vm._v(" Limpar ")]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "base-filter-menu__menu-body" },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    _vm._l(_vm.filters, function(field) {
                      return _c(
                        "v-col",
                        _vm._b(
                          {
                            key: field.key || field.startKey,
                            staticClass: "base-filter-menu__field",
                            attrs: { cols: field.cols || 12 }
                          },
                          "v-col",
                          field.col || {},
                          false
                        ),
                        [
                          field.label
                            ? _c(
                                "span",
                                { staticClass: "az-text-label d-block" },
                                [_vm._v(" " + _vm._s(field.label) + " ")]
                              )
                            : _vm._e(),
                          field.type === "slot"
                            ? _vm._t("field-" + field.key, null, {
                                field: field,
                                draft: _vm.draft
                              })
                            : field.type === "date-range"
                            ? _c(
                                "FilterDates",
                                _vm._b(
                                  {
                                    attrs: {
                                      "start-date": _vm.draft[field.startKey],
                                      "end-date": _vm.draft[field.endKey],
                                      "width-fields": field.widthFields || 140,
                                      vertical: field.vertical,
                                      "use-label-above": "",
                                      clearable: ""
                                    },
                                    on: {
                                      "update:startDate": function($event) {
                                        return _vm.$set(
                                          _vm.draft,
                                          field.startKey,
                                          $event
                                        )
                                      },
                                      "update:start-date": function($event) {
                                        return _vm.$set(
                                          _vm.draft,
                                          field.startKey,
                                          $event
                                        )
                                      },
                                      "update:endDate": function($event) {
                                        return _vm.$set(
                                          _vm.draft,
                                          field.endKey,
                                          $event
                                        )
                                      },
                                      "update:end-date": function($event) {
                                        return _vm.$set(
                                          _vm.draft,
                                          field.endKey,
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  "FilterDates",
                                  field.props || {},
                                  false
                                )
                              )
                            : _c(
                                "input-by-type",
                                _vm._b(
                                  {
                                    attrs: {
                                      value: _vm.draft[field.key],
                                      type: field.type,
                                      options: _vm.resolveOptions(field),
                                      "key-id": field.value,
                                      "key-item": field.text,
                                      placeholder: field.placeholder,
                                      "max-width": field.maxWidth || "100%"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onFieldInput(field, $event)
                                      }
                                    }
                                  },
                                  "input-by-type",
                                  field.props || {},
                                  false
                                )
                              )
                        ],
                        2
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "div",
                {
                  staticClass:
                    "base-filter-menu__menu-footer d-flex justify-end align-center"
                },
                [
                  _vm.$slots["footer-leading"] ||
                  _vm.$scopedSlots["footer-leading"]
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "base-filter-menu__footer-leading mr-auto"
                        },
                        [_vm._t("footer-leading")],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "BaseButton",
                    {
                      attrs: {
                        underlined: "",
                        fitContent: "",
                        "min-width": "auto"
                      },
                      on: { click: _vm.cancelFilters }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: {
                        primary: "",
                        fitContent: "",
                        "min-width": "110px"
                      },
                      on: { click: _vm.applyFilters }
                    },
                    [_vm._v(" Aplicar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }